import request from '@/http/request'

// /api/exportlog/list

// 查看系统导出记录列表
export const getExportList = (data) => {
    return request.request({
        url: '/api/exportlog/list',
        method: 'POST',
        data
    })
}
